export enum SubscriptionStatusErrorCode {
	UnexpectedError = 1000,
	TenantUnknown = 2000,
	SubscriptionExpired = 3000,
	SubscriptionNotFound = 3001
}
